import {compose, pick} from 'ramda'
import {
  FIELD_NAME_TO_PROPERTY_NAME_MAPPING,
  BENEFICIAL_OWNER_DOCUMENT_INPUT_FIELD_NAMES,
  BENEFICIAL_OWNER_PERSON_INPUT_FIELD_NAMES,
  BENEFICIAL_OWNER_ROLE_INPUT_FIELD_NAMES,
} from './constants'

export const pickBeneficialOwnerPersonProperties = pick(BENEFICIAL_OWNER_PERSON_INPUT_FIELD_NAMES)
export const pickBeneficialOwnerRoleProperties = pick(BENEFICIAL_OWNER_ROLE_INPUT_FIELD_NAMES)
export const pickBeneficialOwnerDocumentProperties = pick(
  BENEFICIAL_OWNER_DOCUMENT_INPUT_FIELD_NAMES
)
const pickAllBeneficialOwnerProperties = pick([
  ...BENEFICIAL_OWNER_PERSON_INPUT_FIELD_NAMES,
  ...BENEFICIAL_OWNER_ROLE_INPUT_FIELD_NAMES,
])

const fieldNameToProperty = (fieldName: string): string => {
  if (FIELD_NAME_TO_PROPERTY_NAME_MAPPING[fieldName]) {
    return FIELD_NAME_TO_PROPERTY_NAME_MAPPING[fieldName]
  }
  return fieldName.replace('ultimateBeneficialOwner.', '')
}

export const mapBeneficialOwnerToRequest = (formData: Record<string, any>): Record<string, any> =>
  Object.fromEntries(
    Object.entries(formData).map(([fieldName, value]) => [fieldNameToProperty(fieldName), value])
  )

const propertyToFieldName = (propertyName: string): string => {
  if (Object.values(FIELD_NAME_TO_PROPERTY_NAME_MAPPING).includes(propertyName)) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return Object.entries(FIELD_NAME_TO_PROPERTY_NAME_MAPPING).find(
      ([, value]) => value === propertyName
    )![0]
  }
  return `ultimateBeneficialOwner.${propertyName}`
}

const mapBeneficialOwnerPropertiesToInputFieldNames = (
  legalRepresentative: Record<string, any>
): Record<string, any> =>
  Object.fromEntries(
    Object.entries(legalRepresentative).map(([propertyName, value]) => [
      propertyToFieldName(propertyName),
      value,
    ])
  )

export const mapBeneficialOwnerToFormData = compose(
  pickAllBeneficialOwnerProperties,
  mapBeneficialOwnerPropertiesToInputFieldNames
)
